export var addScore = function addScore(score) {
  return {
    type: 'ADD_SCORE',
    score: score
  };
};
export var checkWinState = function checkWinState() {
  return {
    type: 'CHECK_WIN_STATE'
  };
};